import styled, { css } from 'styled-components';
import { SearchModes } from '@/domainLogic/index.ts';

export const TitleStyled = styled.div<{
  isIndex?: boolean;
  isWaiting: boolean;
  listView?: boolean | null;
  hasPreselectedFlight?: boolean;
  searchMode: SearchModes;
}>`
  width: 100%;
  position: relative;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  transition: height 0.2s ease-in-out;
  margin-bottom: 16px;
  margin-top: 16px;

  b {
    color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  }

  ${({ isWaiting }) =>
    isWaiting &&
    css`
      @media (max-width: 767px) {
        body:has(.no-results) & {
          display: none;
        }
      }
    `}

  ${({ isIndex }) =>
    isIndex &&
    css`
      padding: 0;
    `};

  ${({ searchMode }) =>
    searchMode === SearchModes.HO &&
    css`
      margin-top: 24px;
    `};

  @media (min-width: 1024px) {
    ${({ isIndex }) =>
      isIndex &&
      css`
        margin-top: 16px;
        min-height: 55px;
      `}

    ${({ isWaiting }) =>
      isWaiting &&
      css`
        margin-bottom: 17px;
      `}
    
    ${({ hasPreselectedFlight }) =>
      hasPreselectedFlight &&
      css`
        margin-bottom: 16px;
      `}
    
    ${({ listView }) =>
      listView &&
      css`
        padding: 0;
        margin-top: 0;
        overflow: unset;
      `}
  }
}
`;

export const MainTitleStyled = styled.div<{
  hasPreselectedFlight?: boolean;
  isWaiting: boolean;
}>`
  font-style: normal;
  font-weight: ${({ theme }) => theme.kallisto.font.weight.semibold};
  font-size: 22px;
  line-height: 30px;
  position: relative;
  width: 100%;

  @media (min-width: 768px) {
    font-size: 28px;
    line-height: 38px;
  }

  ${() => css`
    font-style: normal;
    font-size: 20px;
    font-weight: ${({ theme }) => theme.kallisto.font.weight.bold};
    line-height: ${({ theme }) => theme.kallisto.font.lineHeight['350']};
    @media (min-width: 768px) {
      ${({ theme }) => theme.kallisto.mixins.font('Title2')};
    }
  `}

  ${({ hasPreselectedFlight }) =>
    hasPreselectedFlight &&
    css`
      margin-bottom: 24px;
      padding-bottom: 17px;

      &:after {
        content: '';
        height: 1px;
        background-color: ${({ theme }) => theme.kallisto.color.common.black[100]};
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
      }
    `}
`;
